/**
 * Event Configurator — Gratis Sync
 *
 * Synchronisiert Gratis-Artikel (Strohhalmset + Puncher) im Warenkorb
 * wenn Wedding-Edition Produkte vorhanden sind.
 *
 * Performance: Macht KEINE Requests bis der Konfigurator das Flag
 * 'ec-gratis-active' in sessionStorage setzt. Ohne Flag = 0 Overhead.
 *
 * Gratis-Toggles: Liest 'ec-straw-enabled' und 'ec-puncher-enabled'
 * aus sessionStorage. Wenn '0', wird der jeweilige Artikel nicht
 * synchronisiert und ggf. auf 0 gesetzt.
 *
 * Einbindung in theme.liquid vor </body>:
 * <script src="{{ 'ec-gratis-sync.js' | asset_url }}" defer></script>
 */
(function () {
  var FLAG = 'ec-gratis-active';
  var STRAW_FLAG = 'ec-straw-enabled';
  var PUNCHER_FLAG = 'ec-puncher-enabled';

  // ── Variant IDs (Wedding Editions) ──
  var PREMIUM_VARIANT = 52631896293642;
  var HUGO_VARIANT_1 = 52631898095882;
  var HUGO_VARIANT_2 = 53061159158026;

  // Gratis-Produkte
  var STRAW_VARIANT = 45368383013130;
  var PUNCHER_VARIANT = 52631695753482;

  var isSyncing = false;
  var intervalId = null;

  function isActive() {
    try { return sessionStorage.getItem(FLAG) === '1'; }
    catch (e) { return false; }
  }

  function isStrawEnabled() {
    try { return sessionStorage.getItem(STRAW_FLAG) !== '0'; }
    catch (e) { return true; }
  }

  function isPuncherEnabled() {
    try { return sessionStorage.getItem(PUNCHER_FLAG) !== '0'; }
    catch (e) { return true; }
  }

  // Dynamische Gratis-ID-Liste basierend auf Flags
  function getGratisIds() {
    var ids = [];
    if (isStrawEnabled()) ids.push(STRAW_VARIANT);
    if (isPuncherEnabled()) ids.push(PUNCHER_VARIANT);
    return ids;
  }

  // ── Sync Logic ──
  function syncGratis() {
    if (!isActive() || isSyncing) return;
    isSyncing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var premiumQty = 0;
        var hugoQty = 0;

        cart.items.forEach(function (item) {
          var vid = Number(item.variant_id);
          if (vid === PREMIUM_VARIANT) premiumQty = item.quantity;
          if (vid === HUGO_VARIANT_1 || vid === HUGO_VARIANT_2) hugoQty += item.quantity;
        });

        var totalBoxes = premiumQty + hugoQty;
        var totalPiccolos = totalBoxes * 24;
        var gratisIds = getGratisIds();

        // Keine Hauptprodukte mehr → Gratis entfernen + deaktivieren
        if (totalBoxes === 0) {
          var hasGratis = cart.items.some(function (item) {
            return [STRAW_VARIANT, PUNCHER_VARIANT].indexOf(Number(item.variant_id)) > -1;
          });
          if (hasGratis) {
            var updates = {};
            updates[STRAW_VARIANT] = 0;
            updates[PUNCHER_VARIANT] = 0;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function () {
              deactivate();
              refreshCartUI();
            });
          } else {
            deactivate();
          }
          return;
        }

        // Zielmengen berechnen (0 wenn deaktiviert)
        var targetStraw = isStrawEnabled() ? Math.ceil(totalPiccolos / 50) : 0;
        var targetPuncher = isPuncherEnabled() ? hugoQty : 0;

        var currentStraw = 0;
        var currentPuncher = 0;
        cart.items.forEach(function (item) {
          var vid = Number(item.variant_id);
          if (vid === STRAW_VARIANT) currentStraw = item.quantity;
          if (vid === PUNCHER_VARIANT) currentPuncher = item.quantity;
        });

        if (currentStraw !== targetStraw || currentPuncher !== targetPuncher) {
          var updates = {};
          updates[STRAW_VARIANT] = targetStraw;
          updates[PUNCHER_VARIANT] = targetPuncher;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function () {
            refreshCartUI();
          });
        } else {
          hideGratisControls();
        }
      })
      .catch(function (err) {
        console.error('Gratis-Sync Fehler:', err);
      })
      .finally(function () {
        isSyncing = false;
      });
  }

  function deactivate() {
    try { sessionStorage.removeItem(FLAG); } catch (e) {}
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  function activate() {
    if (!intervalId) {
      intervalId = setInterval(syncGratis, 5000);
    }
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('theme:cart:change'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartDrawer.renderContents(cart);
          hideGratisControls();
        });
    } else {
      hideGratisControls();
    }
  }

  function hideGratisControls() {
    if (!isActive()) return;

    var old = document.getElementById('ec-gratis-hide-css');
    if (old) old.remove();

    var style = document.createElement('style');
    style.id = 'ec-gratis-hide-css';

    var gratisIds = getGratisIds();
    if (gratisIds.length === 0) return;

    var rules = gratisIds.map(function (gid) {
      var sel = '.cart__item[data-item^="' + gid + '"]';
      return sel + ' .cart__quantity-minus,' +
        sel + ' .cart__quantity-plus,' +
        sel + ' .cart__item__remove,' +
        sel + ' [data-item-remove]';
    }).join(',');

    style.textContent = rules + '{ display: none !important; }' +
      gratisIds.map(function (gid) {
        return '.cart__item[data-item^="' + gid + '"] .cart__quantity-field';
      }).join(',') + '{ pointer-events: none !important; -moz-appearance: textfield !important; }';
    document.head.appendChild(style);
  }

  // ── Init ──
  if (isActive()) {
    activate();
    setTimeout(syncGratis, 600);
  }

  document.addEventListener('theme:cart:added', function () {
    if (isActive()) { activate(); setTimeout(syncGratis, 400); }
  });
  document.addEventListener('theme:cart:change', function () {
    if (isActive()) setTimeout(syncGratis, 400);
  });

  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver(function () {
      if (isActive()) hideGratisControls();
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  if (isActive() && window.location.pathname === '/cart') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(hideGratisControls, 500);
    });
  }
})();